import React, { useEffect, useState } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

// img
import shap1 from "../../../assets/images/shapes/01.png";
import shap2 from "../../../assets/images/shapes/02.png";
import shap3 from "../../../assets/images/shapes/03.png";
import shap4 from "../../../assets/images/shapes/04.png";
import shap5 from "../../../assets/images/shapes/05.png";
import shap6 from "../../../assets/images/shapes/06.png";
import { getAllUsers, getStatistics } from "../../../helpers/auth";

const UserList = () => {
  const [userlist, setUserlist] = useState([]);

  const ApiCall = async () => {
    let data = await getAllUsers();
    setUserlist(data);
  };

  useEffect(() => {
    ApiCall();
  }, []);

  console.log(userlist, "userlist");
  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">User List</h4>
                </div>
              </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        {/* <th>Country</th> */}
                        <th>Status</th>
                        {/* <th>Company</th> */}
                        <th>Join Date</th>
                        {/* <th min-width="100px">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {userlist.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center">
                            <Image
                              className="bg-soft-primary rounded img-fluid avatar-40 me-3"
                              src={
                                item?.profileimage
                                  ? item.profileimage
                                  : "https://source.unsplash.com/user/c_v_r/100x100"
                              }
                              alt="profile"
                            />
                          </td>
                          <td>{item.name}</td>
                          {/* <td>{item.phone}</td> */}
                          <td>{item.email}</td>
                          <td>{item.role}</td>
                          <td>
                            <span
                              className={`badge ${
                                item.isVerified ? "bg-success" : "bg-danger"
                              }`}
                            >
                              {item.isVerified ? "Verified" : "Not Verified"}
                            </span>
                          </td>
                          {/* <td>{item.company}</td> */}
                          <td>{item.createdAt}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserList;
